import { render, staticRenderFns } from "./exam.vue?vue&type=template&id=338f3425&scoped=true"
import script from "./exam.vue?vue&type=script&lang=js"
export * from "./exam.vue?vue&type=script&lang=js"
import style0 from "../assets/css/exam.scss?vue&type=style&index=0&id=338f3425&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338f3425",
  null
  
)

export default component.exports